import { removeTrailingSlash } from 'ha/utils/urls/removeTrailingSlash';

export function onEnterDefault(nextState, replace, callback) {
  if (nextState.location.pathname.endsWith('/')) {
    replace({
      ...nextState.location,
      pathname: removeTrailingSlash(nextState.location.pathname),
    });
  }

  callback();
}
